
























import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { AvatarSize } from '@getaccept/lib-ui';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { ChatParticipant, Conversation, Message, Typing } from '../types';
import { ConversationType } from '../types';
import { ChatHelper } from '../helpers';
import ChatTypingStatus from './ChatTypingStatus.vue';
import ChatListAvatars from './ChatListAvatars.vue';

export default defineComponent({
  components: {
    ChatTypingStatus,
    ChatListAvatars,
  },
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      default: () => ({}),
    },
    participants: {
      type: Array as PropType<ChatParticipant[]>,
      default: () => [],
    },
    user: {
      type: Object as PropType<User>,
      default: () => ({} as User),
    },
    recipientId: {
      type: String,
      default: '',
    },
    typing: {
      type: Array as PropType<Array<Typing>>,
      default: () => [],
    },
    recipients: {
      type: Array as PropType<Recipient[]>,
      default: () => [],
    },
  },
  setup(props) {
    const owner = computed(() =>
      props.recipientId
        ? { recipientId: props.recipientId }
        : { user: props.user, userId: props.user.id }
    );

    const isTypingInConversation = (conversationId: string, typing: Typing[]) =>
      typing.some(
        t =>
          t.conversationId === conversationId &&
          !ChatHelper.isSameParticipant(t.participant, owner.value)
      );

    const getParticipantNames = computed(() =>
      props.conversation.type === ConversationType.General
        ? t('dsr_chat_all_participants')
        : ChatHelper.getParticipantNames(props.participants, props.conversation.participants)
    );

    const getLatestMessage = (messages: Message[]) => {
      const latestMessage = ChatHelper.getLastMessage(messages);

      const sender = ChatHelper.getRecipient(latestMessage, props.recipients);
      const firstName = sender ? sender.firstName : props.user.firstName;
      if (latestMessage?.deletedAt) {
        return `${firstName} ${t('deleted_a_message')}`;
      }
      return latestMessage?.text ? `${firstName}: ${latestMessage?.text}` : '';
    };

    const isLastMessageUnread = (messages: Message[]) =>
      ChatHelper.isLastMessageUnread(messages, props.user.id, props.recipientId);

    return {
      owner,
      getParticipantNames,
      isTypingInConversation,
      getLatestMessage,
      isLastMessageUnread,

      getParticipantsDetails: ChatHelper.getParticipantsDetails,
      ConversationType,
      AvatarSize,
    };
  },
});
